const SETTINGS = {
    easy: { operators: ['+', '-'], max: 10 },
    medium: { operators: ['+', '-'], max: 100 },
    hard: { operators: ['×', '÷'], max: 9 },
    insane: { operators: ['+', '-', '×', '÷'], max: 100 },
    grade1: { operators: ['+', '-'], max: 10 },
    grade2: { operators: ['+', '-'], max: 100 },
    grade3: { operators: ['×', '÷'], max: 9 },
};

function randomInt(max) {
    return Math.floor(Math.random() * (max + 1));
}

function createAddSub(operator, max) {
    if (operator === '+') {
        const first = randomInt(max);
        const second = randomInt(max - first);
        return [first, second];
    }

    const first = randomInt(max);
    const second = randomInt(first);
    return [first, second];
}

function createMultiplyDivide(operator) {
    if (operator === '×') return [randomInt(8) + 1, randomInt(8) + 1];

    const dividend = randomInt(8) + 1;
    const divisors = [];
    for (let divisor = 1; divisor <= dividend; divisor += 1) {
        if (dividend % divisor === 0) divisors.push(divisor);
    }
    const divisor = divisors[randomInt(divisors.length - 1)];
    return [dividend, divisor];
}

function calculateAnswer(operator, number1, number2) {
    if (operator === '+') return number1 + number2;
    if (operator === '-') return number1 - number2;
    if (operator === '×') return number1 * number2;
    return number1 / number2;
}

function questionGenerator(difficulty = 'easy') {
    const setting = SETTINGS[difficulty] || SETTINGS.easy;
    const operator = setting.operators[randomInt(setting.operators.length - 1)];
    const [number1, number2] = ['×', '÷'].includes(operator)
        ? createMultiplyDivide(operator)
        : createAddSub(operator, setting.max);

    const answer = calculateAnswer(operator, number1, number2);

    return { text: `${number1} ${operator} ${number2}`, answer };
}

export default questionGenerator;
